export const upcomingRaceEntryQueryKeys = {
  all: () => "upcoming-race-entry"
};
